<template lang="pug">
  .students
    //-.info-thing
      .revision-history
        span List is accurate as of April 25, 2022. Additional attendees will be added the next time the list is updated.


    p COMING SOON

    //-.table-thing
      table
        tr
          th First
          th Middle
          th Last
          //-th Nickname
          th School
        tr(v-for="student in formatted_students")
          td {{ student.first_name }}
          td {{ student.Initial }}
          td {{ student.last_name }}
          //-td {{ student.nick_name }}
          td {{ student.School }}
          //-td
            a.link(:href="'mailto:cb50threunionclassof1970@gmail.com?subject=Information about ' + student.name")
              span Email Information
    
      //-.gallery
        .person(v-for="(student, index) in students")
          .image(@click="select(index)")
            label(:class="{ need: student.status === 'NEED INFORMATION', have: student.status === 'HAVE INFORMATION', dead: student.status === 'DECEASED' }") {{student.status}}
            img(:src="base + 'images/' + student.url")

</template>

<script>

import attending from '@/assets/attending'

//console.log(students)
//const base = (process.env.NODE_ENV === 'production') ? '/' : 'http://cb1970.com/'

export default {
  name: 'Attending',
  components: {
  },
  data () {
    return {
      attending
    }
  },
  mounted () {
  },
  computed: {
    formatted_students () {
      return []
      /*return this.attending.map(student => {
        return {
          ...student,
          name: `${student.first_name} ${student.last_name}`
        }
      })*/
    }
  },
  methods: {
  }
}
</script>

<style lang="stylus">
  .info-thing
    //background-color #fff
    border 0px solid #fff
    //overflow hidden
    margin-bottom 40px
    em
      color #c62828
      font-weight 500
  .revision-history
    padding-top 20px
    color #777
    font-size 12px
  .info-thing,
  .table-thing
    padding 0 20px
  .students
    table 
      text-align left
      width 100%
      tr:nth-child(even)
        background-color #f3f3f3
      img
        max-height 100px
        vertical-align top
      th, td
        padding 10px
  .downloads
    display flex
    margin-bottom 20px
    a.button
      margin-right 20px
      
</style>
